module.exports = __webpack_public_path__ + "media/dworld_trailer.fe50b417.mp4";